<script>
import {  mapGetters } from 'vuex'
// eslint-disable-next-line
export default {
    computed: {
        ...mapGetters('emulator', ['hasSettingChange']),
        designer() {
            return window.__EMULATOR_DESIGNER__
        },
        currentDocument() {
            return this.designer?.project?.currentDocument || {}
        },
        hasDocumentChange() {
            return this.currentDocument?.hasChange
        },
        hasChange() {
            return this.hasDocumentChange || this.hasSettingChange
        },
    },
   
    render() {
        return (
            <div>
                {
                    <ThemeDesigner ref="theme" ></ThemeDesigner> //NOSONAR
                }
            </div>
        )
    },
}
</script>
